import React, { useEffect, useRef, useState } from 'react'
import {
    AlertType, KEY_CODE_ENTER, KEY_CODE_ESCAPE, Produto, classBorderLabelDark, classBt, classInput, classInputDark, classLabel,
    classLabelDark, classbtAzul, classbtColunasAzul, classbtColunasVermelho
} from '../../Utils/Types'
import { ProdutoService } from '../../Pages/Products/ProdutoService'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { Funcoes } from '../../Utils/Funcoes'
import { LuPackageSearch } from 'react-icons/lu'
import { IoSearch } from 'react-icons/io5'
import { BsArrowDownSquareFill, BsArrowUpSquareFill } from 'react-icons/bs'

type Props = {
    visible: boolean
    visible_Modal_Abrir_Grade_Venda?: boolean
    loading?: boolean
    stringDesc?: string
    onVisibleOpen?: () => void
    onDadosId?: (idProduto: number) => void
    consultarCodBarraEvent: (codBarraBuscaProd: string) => void
    closeModalEvent: () => void
}

export const ModalBuscaProduto = React.memo(({ visible, visible_Modal_Abrir_Grade_Venda, loading, stringDesc, onVisibleOpen, onDadosId, consultarCodBarraEvent, closeModalEvent }: Props) => {

    const [idProdBuscar, setIdProdBuscar] = useState(0)                             // Variavel para guardar o id do Produto Selecionado.
    const [descProdBuscar, setDescProdBuscar] = useState("")                        // Variavel para guardar a descrição do Produto.
    const [produtos, setProdutos] = useState<Produto[]>([])                         // Tabela temporaria para poder fazer a manipulação dos dados dos Produtos.
    //const [produtosList, setProdutosList] = useState<Produto[]>([])               // Armazena os dados dos Produtos.
    const [produtosListSelect, setProdutosListSelect] = useState<Produto[]>([])     // Tabela temporaria para poder armazenar e fazer a manipulação dos dados do Produto que foi selecionado.
    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(-1)            // Variavel para armazenar o numero da linha selecionada na tabela 'produtos'.

    const [visibleMsg, setVisibleMsg] = useState(false)                             // Variavel responsavel por controlar a visibilidade da mensagem do sistema.
    const [message, setMessage] = useState("")                                      // Variavel responsavel por guardar a descrição da mensagem do sistema.
    const [messageType, setMessageType] = useState<AlertType>("DANGER")             // Variavel responsavel por guardar o tipo de mensagem seja de alerta, error ou sucesso.

    const [loadingBusca, setLoadingBusca] = useState(false)

    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------//
    useEffect(() => {

        setDescProdBuscar(stringDesc || '')

        if (visible) {

            let modal = document.getElementById('modal_consulta_codBarra')
            let modalContent = document.getElementById('modal-content-consulta-codBarra')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-24')
                }

                const aguarde = setTimeout(() => {
                    const inputCodBarra = document.getElementById('inputCodBarra')
                    if (inputCodBarra) {
                        inputCodBarra.focus()
                        clearTimeout(aguarde)
                    }
                }, 200)
            }

        } else {

            setLinhaSelecionada(-1)
            setIdProdBuscar(0)
            setVisibleMsg(false)
            setProdutos([])
            setProdutosListSelect([])
            setDescProdBuscar('')

            let modal = document.getElementById('modal_consulta_codBarra')
            let modalContent = document.getElementById('modal-content-consulta-codBarra')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-24')
                }
            }
        }

    }, [visible])

    /*
    useEffect(() => {
        setProdutos([])

        const delayDebounceFn = setTimeout(() => {
            if (descProdBuscar && descProdBuscar.length > 0) {
                ProdutosFilter()  // Chama a função após 0,5 segundos de inatividade
                setVisibleMsg(false)
            } else {
                setProdutosListSelect([])
            }
        }, 500) // 500 milisegundos

        // Limpa o timeout se descProdBuscar mudar antes de completar os 0,5 segundos
        return () => clearTimeout(delayDebounceFn)

    }, [descProdBuscar])
    */

    /*
    useEffect(() => {
        setProdutos([])

        if (descProdBuscar && descProdBuscar.length > 0) {

            ProdutosFilter()

            
            const descProdSemAcento = removerAcentos(descProdBuscar).toLocaleLowerCase()
            const newProdList = produtosList.filter((item) => {
                const itemSemAcento = removerAcentos(item.descricao).toLocaleLowerCase()
                return itemSemAcento.startsWith(descProdSemAcento)
            })
            

            const limitedProdList = newProdList.slice(0, 50)
            

            if (newProdList.length != produtos.length) {
                
            }

            console.log("newProdList: " , newProdList)
            console.log("limitedProdList: " , limitedProdList)
            

            //setLinhaSelecionada(-1)
            //setProdutos(limitedProdList)


        } else {

            setProdutosListSelect([])

        }

    }, [descProdBuscar])
    
    */

    useEffect(() => {

        const handleKeyPressEnter = (event: any) => {

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && visible && !loadingBusca && !loading) {

                if (!visible_Modal_Abrir_Grade_Venda && linhaSelecionada !== -1) {
                    abrirModalGradeVenda();
                } else {
                    ProdutosFilter()
                }
            }

        }

        const handleKeyPressESC = (event: any) => {
            if (event.code === KEY_CODE_ESCAPE && !visible_Modal_Abrir_Grade_Venda && visible && !loadingBusca && !loading) {

                if (closeModalEvent) {
                    closeModalEvent()
                }

            }
        }

        const handleKeyDown = (event: any) => {

            if (!visible_Modal_Abrir_Grade_Venda && visible && !loadingBusca && !loading) {

                const { key } = event

                if (key === 'ArrowUp' || key === 'ArrowDown') {
                    event.preventDefault()

                    let nextIndex
                    if (key === 'ArrowUp') {
                        nextIndex = linhaSelecionada === -1 || linhaSelecionada === 0 ? produtos.length - 1 : linhaSelecionada - 1
                    } else {
                        nextIndex = linhaSelecionada < produtos.length - 1 ? linhaSelecionada + 1 : 0
                    }

                    const selectedItem = produtos[nextIndex]

                    if (selectedItem != undefined) {

                        handleProdSelecionado(selectedItem, nextIndex)
                        setLinhaSelecionada(Math.max(0, Math.min(nextIndex, produtos.length - 1)))
                        setIdProdBuscar(selectedItem.id)

                        const element = document.getElementById(`produto-buscar-${nextIndex}`)
                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest'
                            })
                        }

                    } else {

                        setLinhaSelecionada(-1)
                        setIdProdBuscar(0)
                    }

                    const timer = setTimeout(() => {
                        inputFocus()
                        clearTimeout(timer)
                    }, 0)
                }
            }
        }

        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleKeyPressESC)
        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
            document.removeEventListener('keydown', handleKeyPressESC)
            document.removeEventListener('keydown', handleKeyDown)
        }

    }, [produtos, produtosListSelect, linhaSelecionada, visible_Modal_Abrir_Grade_Venda, visible, loadingBusca, loading, descProdBuscar])

    const ProdutosFilter = async () => {

        setVisibleMsg(false)
        setLoadingBusca(true)
        inputDesfocus()
        setProdutos([])

        try {

            const relatorio = {
                status: "S"
            }

            const newProdList = await ProdutoService.Filter('descricao', descProdBuscar, 'contains', relatorio)
            const limitedProdList = newProdList.data.slice(0, 50)
            setProdutos(limitedProdList)
            setLinhaSelecionada(-1)

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao buscar os produtos`)

        } finally {

            const timer = setTimeout(() => {
                setLoadingBusca(false)
                inputFocus()
                clearTimeout(timer)
            }, 0)
        }

        /*
            const attributes = await ProdutoService.ProdutoList()
            
            if (attributes) {
                //setProdutos(attributes || [])
                setProdutosList(attributes || [])
            }
        */
        //setProdutosList(await ProdutoService.Filter('descricao', 'start', descProdBuscar))

    }

    const inputFocus = () => {
        const inputElement = document.getElementById("inputCodBarra")
        inputElement?.focus()
    }

    const inputDesfocus = () => {
        const inputElement = document.getElementById("inputCodBarra")
        inputElement?.blur()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    //------------------------------------------------------------- LANÇAMENTO DE PRODUTO ------------------------------------------------------------------//
    const handleDescProd = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const valorAtual = e.target.value
        setDescProdBuscar(valorAtual)
        setLinhaSelecionada(-1)
        setIdProdBuscar(0)
        setProdutosListSelect([])
        setProdutos([])

        /*
        // Verifica se o número de caracteres é múltiplo de 4
        if (valorAtual.length % 4 === 0) {
            const produtos = await ProdutoService.Filter('descricao', valorAtual, 'start')
            setProdutosList(produtos)
        }
        */
    }

    const handleProdSelecionado = (item: any, index: number) => {

        /*
        --  No momento do click do mouse eu armazeno os dados do produto selecionado nas variaveis:
            setProdutosListSelect - recebe os dados e armazena numa lista temporaria.
            setLinhaSelecionada   - recebe o numero da linha selecionada.
            setIdProdBuscar       - recebe o id do produto selecionado.
        */

        setProdutosListSelect([item])
        setLinhaSelecionada(index)
        setIdProdBuscar(item.id)
    }

    const lancarProduto = (codBarraGrade: string) => {

        if (visible) {
            setVisibleMsg(false)
            consultarCodBarraEvent(codBarraGrade)
        }
    }

    //------------------------------------------------------------- MODAL GRADE ----------------------------------------------------------------------------//
    const abrirModalGradeVenda = () => {

        setVisibleMsg(false)

        if (produtosListSelect.length > 0 && produtosListSelect[0].isGrade && linhaSelecionada != -1) {

            if (onVisibleOpen) {
                onVisibleOpen()
            }

            if (onDadosId) {
                onDadosId(idProdBuscar || 0)
            }

        } else if (produtosListSelect.length > 0 && linhaSelecionada != -1) {
            lancarProduto(produtosListSelect[0].cod_barra?.toString() || '')
        } else {
            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(`Por favor, selecione um produto`)
                inputFocus()
                clearTimeout(timer)
            }, 250)
        }

    }

    //------------------------------------------------------------- SEM USO --------------------------------------------------------------------------------//
    const removerAcentos = (s: string) => {
        return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    return (

        <div id="modal_consulta_codBarra" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal-content-consulta-codBarra" className={`relative flex flex-col w-[90%] xl:w-[70%] 2xl:w-[60%] h-[500px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                {/* Header */}
                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <LuPackageSearch size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Pesquisar Produto</span>
                </div>
                {/* Header */}

                {/* Body */}
                <div className={`absolute top-[70px] w-full h-full px-3 py-4`}>

                    <div className={`relative w-full flex flex-row space-x-2`}>
                        <input id='inputCodBarra' className={`${classInput} ${classInputDark} h-[48px] text-[18px]`} placeholder='' autoComplete='off' value={descProdBuscar} onChange={handleDescProd} />
                        <label htmlFor="inputCodBarra" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Descrição</label>

                        <button
                            tabIndex={-1}
                            onClick={ProdutosFilter} disabled={loading}
                            className={`${classbtColunasAzul} max-w-[150px] h-[48px]`}>
                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                            {loading &&
                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                </div>
                            }
                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                        </button>

                    </div>

                    <div className={`relative w-full mt-2`}>

                        <div className={`w-full ${produtos.length >= 5 ? `pr-[11px]` : ``}`}>

                            <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                <li className={`h-full border-2 border-white dark:border-slate-600`}>

                                    <div className={`w-full flex flex-row h-10 font-mono`}>

                                        <div className={`flex items-center w-[40%] h-full border border-slate-300  dark:border-slate-700`}>
                                            <span className={`px-2`}>Descrição</span>
                                        </div>

                                        <div className={`flex items-center w-[20%] h-full border border-slate-300  dark:border-slate-700`}>
                                            <span className={`px-2`}>Código de Barras</span>
                                        </div>

                                        <div className={`flex items-center justify-end w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                            <span className={`px-2`}>Estoque</span>
                                        </div>

                                        <div className={`flex items-center w-[15%] h-full border border-slate-300  dark:border-slate-700`}>
                                            <span className={`px-2`}>Unid. Medida</span>
                                        </div>

                                        <div className={`flex items-center justify-end w-[15%] h-full border border-slate-300  dark:border-slate-700`}>
                                            <span className={`px-2`}>Preço(R$)</span>
                                        </div>

                                    </div>
                                </li>
                            </ul>

                        </div>

                        <div className={`h-[250px] overflow-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin`}>

                            <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                <ul id='elementos' className={`w-full`}>
                                    {produtos.length > 0 &&
                                        produtos.map((item, index) => {
                                            return (

                                                <li key={item.id} id={`produto-buscar-${index}`} onClick={() => handleProdSelecionado(item, index)} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 ${index === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-pointer`}>

                                                    <div className={`w-full flex flex-row h-[55px] font-mono`}>

                                                        <div className={`flex items-center w-[40%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.descricao}</span>
                                                        </div>

                                                        <div className={`flex items-center w-[20%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.cod_barra}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[10%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.estoque_fisico}</span>
                                                        </div>

                                                        <div className={`flex items-center w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.id_unid_medida?.description}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{Funcoes.numberFormat(item.preco_v || 0, 'currency')}</span>
                                                        </div>

                                                    </div>

                                                </li>
                                            )
                                        })
                                    }

                                </ul>

                            </div>

                        </div>

                    </div>

                </div>

                {loadingBusca &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-white dark:bg-slate-600 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                {/* Body */}

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <div className={`w-full flex items-center justify-start space-x-1`}>

                        <BsArrowUpSquareFill className={`dark:text-slate-100 text-slate-500 text-xl`} />
                        <BsArrowDownSquareFill className={`dark:text-slate-100 text-slate-500 text-xl`} />
                        <span className='font-semibold dark:text-slate-100 text-slate-500'>Navegação dos produtos</span>

                    </div>

                    <div className={`w-full flex items-center justify-end space-x-3`}>

                        <button
                            tabIndex={-1}
                            onClick={closeModalEvent} disabled={loading}
                            className={`${classbtColunasVermelho} max-w-[150px]`}>
                            CANCELAR
                        </button>

                        <button
                            tabIndex={-1}
                            onClick={abrirModalGradeVenda} disabled={loading}
                            className={`${classbtAzul} ${classBt} max-w-[150px]`}>

                            {loading &&
                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                </div>
                            }
                            {!loading ? `LANÇAR` : `AGUARDE`}

                        </button>

                    </div>


                </div>


            </div>

        </div>
    )
})